import React, { Fragment, Component } from "react";
import { FormGroup, Row, Col, Label, Input } from "reactstrap";
import Autosuggest from "../../../../Autosuggest/Autosuggest";
import styleF from "../Field.module.scss";
import { CircularProgress } from "../../../..";
import Holders from "./Holders";
import Instruction from "./Instruction";
import { clientPrice, commissionSuffix } from "../../Form/commons";
import {
  OrderPriceType,
  getCommissionItems,
  ProductType,
  OrderStatus,
  CommissionType as ComType,
  getBaseAndPriceCurrencies,
} from "../../../../../utils/Order/Order";
import { Field, Numeric, Combobox, Switch } from "../Field";
import QuantityHelper from "../../Helper/QuantityHelper";
import EarningsHelper from "../../Helper/EarningsHelper";
import Balance from "./Balance";
import { UserType, instructionWrittenTypes, instructionWebTypes } from "../../../../../utils/Helper";
import { Dispatch as Context } from "../../store/store";
import { formattedNumber } from "../../../../FormattedNumber/FormattedNumber";
import { ExternalAccountWrapper } from "./ExternalAccountsWrapper";
import { CheckFormField } from "../../../../../utils";
import translate from "../../../../../utils/Translator";

class Account extends Component {
  constructor(props) {
    super(props);
    const { account, balanceReady, opsViewAccountName } = props;
    const { AccountId } = account;
    Account.contextType = Context;

    this.state = {
      loadingHolders: AccountId != null,
      loadingBalance: AccountId != null && balanceReady,
      holders: null,
      balance: null,
      instructions: null,
      sendingMail: false,
      clientBankAccounts: [],
      selectedBankAccount: null,
      useCashAccount: false,
      accountIsJuridical: false,
      ownPositionAccounts: [],
      useCommissionPoints: false,
      commissionPointsLabel: "",
      useCommissionClientPrice: false,
      commissionClientPriceLabel: "",
    };
  }

  // componentWillMount() {
  //   const { account } = this.props;
  //   const { AccountId } = account;

  //   if (AccountId != null) {
  //     this.requestAccountInfo();
  //     this.requestAccountHolders({ accountId: AccountId });
  //   }
  // }

  componentDidMount() {
    this._isMounted = true;
    const { account, userType, platformRole } = this.props;
    const { AccountId, AccountName, AccountNumber, HolderId } = account;

    if (AccountId != null) {
      this.requestAccountInfo({}, false);
      this.requestAccountHolders({ accountId: AccountId });
    }

    if (platformRole == "Trader" || platformRole == "BackOffice" || platformRole == "MiddleOffice") {
      this.props.fetchOwnPositionAccounts().then(({ accounts }) => {
        this.setState({ ownPositionAccounts: accounts });
      });
    }

    if (this.props.getParameterValue) {
      this.props.getParameterValue({ ParameterName: "useCommitionPoints" }, (response) => {
        if (response && response.SdtParametersData && response.SdtParametersData.ParameterNumericValue == 1) {
          const pointsLabel = response.SdtParametersData.ParameterCharacterValueLong || "";

          if (pointsLabel && pointsLabel.trim() !== "") {
            this._isMounted &&
              this.setState({
                useCommissionPoints: true,
                commissionPointsLabel: pointsLabel,
              });
          }
        }
      });

      this.props.getParameterValue({ ParameterName: "useCommitionClientPrice" }, (response) => {
        if (response && response.SdtParametersData && response.SdtParametersData.ParameterNumericValue == 1) {
          const clientPriceLabel = response.SdtParametersData.ParameterCharacterValueLong || "";

          if (clientPriceLabel && clientPriceLabel.trim() !== "") {
            this._isMounted &&
              this.setState({
                useCommissionClientPrice: true,
                commissionClientPriceLabel: clientPriceLabel,
              });
          }
        }
      });
    }

    // Cuando se ve una orden ya viene precargados los valores
    if (!isEmpty(AccountId) && isEmpty(HolderId)) {
      this.onChange("", {
        id: AccountId,
        name: AccountName,
        number: AccountNumber,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { account, balanceReady, updateAccount, order, onChange } = this.props;
    const { AccountId, HolderId, clientBankAccount, CommissionType, Commission } = account;

    if (prevProps.order.OrderType !== order.OrderType) {
      const currentTypeSupportsPoints = [
        OrderPriceType.LIMIT,
        OrderPriceType.STOPLIMIT,
        OrderPriceType.MARKET,
      ].includes(order.OrderType);
      const currentTypeSupportsClientPrice = [OrderPriceType.LIMIT, OrderPriceType.MARKET].includes(
        order.OrderType,
      );

      if (!currentTypeSupportsPoints && this.state.useCommissionPoints) {
        if (CommissionType === "Points") {
          onChange({ CommissionType: null });
        }
      }

      if (!currentTypeSupportsClientPrice && this.state.useCommissionClientPrice) {
        if (CommissionType === "ClientPrice") {
          onChange({ CommissionType: null });
        }
      }
    }

    if (prevProps.order.OrderSide !== order.OrderSide || prevProps.order.OrderPrice !== order.OrderPrice) {
      const isClientPriceMode =
        this.state.useCommissionClientPrice &&
        [OrderPriceType.LIMIT, OrderPriceType.MARKET].includes(order.OrderType) &&
        CommissionType === "ClientPrice";

      if (isClientPriceMode) {
        const clientPrice = order.CurrentAccount.ClientPrice;
        const orderPrice =
          order.OrderType === OrderPriceType.MARKET ? this.getMarketReferencePrice(order) : order.OrderPrice;

        if (!clientPrice || !orderPrice || clientPrice === "" || orderPrice === "") {
          // Solo actualizar si Commission no está ya vacío
          if (Commission !== "" && Commission !== null && Commission !== undefined) {
            onChange({ Commission: "" });
          }
        } else {
          const clientPriceNum = +clientPrice;
          const priceNum = +orderPrice;
          let calculatedCommission;

          if (order.AssetPriceIsDiscounted) {
            if (order.OrderSide === "Buy") {
              calculatedCommission = priceNum - clientPriceNum;
            } else {
              calculatedCommission = clientPriceNum - priceNum;
            }
          } else {
            // Lógica normal
            if (order.OrderSide === "Buy") {
              calculatedCommission = clientPriceNum - priceNum;
            } else {
              calculatedCommission = priceNum - clientPriceNum;
            }
          }

          // Solo actualizar si el valor calculado es diferente
          if (+Commission !== calculatedCommission) {
            onChange({ Commission: calculatedCommission });
          }
        }
      }
    }

    // Caso especifico cuando se elige el ticker del selector
    if ((balanceReady && !prevProps.balanceReady && AccountId) || prevProps.updateAccount != updateAccount) {
      const isRepoSellEdit = order && order.OrderId > 0;
      this.requestAccountInfo({}, isRepoSellEdit ? false : true);
    }
    // if (
    //   (this.props.getUserExternalAccounts &&
    //     HolderId &&
    //     prevProps.account &&
    //     (prevProps.account.HolderId !== HolderId ||
    //       (order.AssetId && prevProps.order.AssetId !== order.AssetId))) ||
    //   order.OrderSide !== prevProps.order.OrderSide
    // ) {
    //   this.props
    //     .getUserExternalAccounts({ personId: HolderId, accountId: AccountId })
    //     .then((res) => {
    //       const { clientBankAccounts } = res.response;
    //       if (clientBankAccounts.length > 0) {
    //         const filteredAccounts = clientBankAccounts.filter(
    //           (accounts) => accounts.currencyISO === order.OrderCurrencySymbol
    //         );
    //         this.props.onChange({
    //           clientBankAccounts: filteredAccounts,
    //           clientBankAccount: null,
    //           useCashAccount: false,
    //         });
    //       } else {
    //         this.props.onChange({ clientBankAccounts: [], clientBankAccount: null, useCashAccount: false });
    //       }
    //     })
    //     .catch((e) => console.error(e));
    // } else {
    //   if (order.OrderAssetData && order.CurrentAccount.useCashAccount) {
    //     this.props.onChange({ clientBankAccount: null, useCashAccount: false });
    //   }
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSuggestionsFetchRequested = ({ value }) =>
    this.props.searchAccount({ text: value }).then((response) => {
      const useExternal = !!response.response.useExternal;
      let persons = [];
      let userType = "";
      let clientType = "";
      let status = "";
      let checksum = "";
      let accountIsPer = false;

      const ext = response.response.SearchAccountExternal_out;
      if (ext) {
        persons = ext.persons || [];
        userType = ext.userType || "";
        clientType = ext.clientType || "";
        status = ext.status || "";
        checksum = ext.checksum || "";
        accountIsPer = ext.accountIsPer || false;
      }
      return response.response.accounts.map((a) => {
        const accountAttrs = JSON.parse(a.Value);
        return {
          id: a.Id,
          name: accountAttrs.value,
          number: accountAttrs.key,
          useExternal,
          persons,
          userType,
          clientType,
          status,
          checksum,
          accountIsPer,
          ext,
        };
      });
    });

  onChangeAccountHolder = (value) => {
    const holderItem = getItemById(this.state.holders, value);

    let currentInstruction = -1;
    let currentInstructionType = -1;
    if (this.props.order.CurrentAccount) {
      currentInstruction = this.props.order.CurrentAccount.Instruction;
      currentInstructionType = this.props.order.CurrentAccount.InstructionType;

      if (holderItem.instructions.find((ins) => ins.id == currentInstruction) === undefined) {
        // If the current instruction is not available to the new holder,
        // select the first instruction available to the holder.
        currentInstruction = holderItem.instructions[0].id;
      }
    }

    this.setState({
      instructions: holderItem.instructions,
      accountIsJuridical: holderItem.HolderIsJuridical,
      isMainHolder: holderItem.isMain,
    });

    this.props.onChange({
      HolderId: holderItem.id,
      HolderName: holderItem.description,
      Instruction: currentInstruction,
      InstructionType: currentInstructionType,
    });
  };

  onChangeInstruction = ({ type, value }) => {
    if (type === "instructionType") {
      const instructionItem = getItemById(
        Instruction.id === "Written" ? instructionWrittenTypes : instructionWebTypes,
        value,
      );
      this.props.onChange({
        InstructionType: instructionItem.id,
      });
    } else if (type === "instruction") {
      const instructionItem = getItemById(this.state.instructions, value);
      this.props.onChange({
        Instruction: instructionItem.id,
      });
    }
  };

  getMarketReferencePrice = (order) => {
    const items = order.OrderAssetData && order.OrderAssetData.items;
    const rawItemRef = items && (items["Ref Price Default"] || items["Ref Price"]);
    const rawRefPrice = rawItemRef != null && rawItemRef !== "" ? rawItemRef : order.AssetRefPrice;

    if (rawRefPrice === undefined || rawRefPrice === null || rawRefPrice === "") {
      return order.OrderPrice;
    }

    const cleaned = `${rawRefPrice}`
      .split(":")
      .pop()
      .replace(/[^0-9.\-]/g, "");
    const parsed = parseFloat(cleaned);

    return Number.isNaN(parsed) ? order.OrderPrice : parsed;
  };

  requestAccountInfo = (body, updateOrderValues) => {
    if (this.props.balanceReady) {
      const assetTicker =
        this.props.order.AssetClassForm === ProductType.REPO &&
        this.props.order.CurrentAccount.Collateral &&
        this.props.order.CurrentAccount.Collateral.length
          ? this.props.order.CurrentAccount.Collateral[0].AssetTicker
          : this.props.order.AssetTicker;

      this.setState({ loadingBalance: true });

      this.props.accountInfo({ ...body }, updateOrderValues).then((response) => {
        const { balance, accountInfo, balanceWithBooktype } = response.response.accountorderdata;
        const { AccountAsksCustody, AccountType, AccountInBalanceType, AccountUseMarkUP } = accountInfo;

        const assetBalanceItem = balance.find((item) => item.key == assetTicker);
        const assetBalance = assetBalanceItem ? parseFloat(assetBalanceItem.value) : 0.0;

        let modsOnAccount = {
          AccountAsksCustody,
          AccountType,
          AccountInBalanceType,
          AccountAssetBalance: assetBalance,
          AccountUseMarkUP,
        };
        if (AccountAsksCustody) {
          modsOnAccount.RequiresSpecialCustody = true;
        }

        if (this._isMounted) {
          this.setState({
            balance: balanceWithBooktype ? balanceWithBooktype : balance,
            loadingBalance: false,
          });
          this.props.onChange(modsOnAccount);
        }
      });
    }
  };

  requestAccountHolders = ({ accountId }) => {
    this.props.accountHolders({ accountId }).then((response) => {
      const { holders } = response.response;
      const _holders = holders
        .filter((h) => h.HoldersOrderNO || h.HoldersOrderW || h.HoldersOrderV || h.HoldersOrderL)
        .map((h) => ({
          isMain: h.IsMain,
          description: h.PersonName,
          instructions: getInstructions(h, this.props.order.OrderIsBasket),
          id: h.PersonId,
          isJuridical: h.HolderIsJuridical,
        }));

      let selectedHolder = _holders.find((h) => h.isMain) || (_holders.length ? _holders[0] : null);

      if (this.props.order.CurrentAccount && this.props.order.CurrentAccount.HolderId > 0) {
        selectedHolder = _holders.find((h) => h.id == this.props.order.CurrentAccount.HolderId);
        if (selectedHolder === undefined) {
          selectedHolder = null;
        }
      }

      this._isMounted &&
        this.setState(
          {
            holders: _holders,
            loadingHolders: false,
            instructions: selectedHolder && selectedHolder.instructions,
            accountIsJuridical: selectedHolder && selectedHolder.isJuridical,
            isMainHolder: selectedHolder && selectedHolder.isMain,
          },
          () => {
            const { account } = this.props;
            const { HolderId } = account;

            if (HolderId == null && selectedHolder) {
              const { id, description, instructions } = selectedHolder;
              const instruction = instructions && instructions.length ? instructions[0] : null;
              const instructionType =
                (instruction &&
                  (instruction.id === "Written"
                    ? !account.instructionType
                      ? !account.instructionType
                      : instructionWrittenTypes[0].id
                    : null)) ||
                (instruction.id === "Web" ? !account.instructionType && instructionWebTypes[0].id : null);
              this.props.onChange({
                HolderId: id,
                HolderName: description,
                Instruction: instruction ? instruction.description : null,
                InstructionType: instructionType,
              });
            }
          },
        );
    });
  };

  onChange = (method, value) => {
    let _value = defaultAccountValue;

    if (method != "type" && value.id) {
      _value = {
        AccountNumber: value.number,
        AccountName: value.name,
        AccountId: value.id,
      };
      if (value.useExternal && value.userType == 1) {
        this.props
          .ManageCustomerExternalAccount({
            customerNumber: value.number,
            SDT_PersonExternal: value.persons,
            clientType: value.clientType,
            status: value.status,
            checksum: value.checksum,
            CustomerAccountManager_in: { ...value.ext },
          })
          .then((resp) => {
            if (resp.response.result.Code == 200) {
              const updated = { ..._value, AccountId: resp.response.AccountId };
              if (this.props.order.OrderIsBasket) {
                this.props.setBasketErrors({ ...this.props.errors, AccountName: undefined });
              }
              this.requestAccountInfo(updated, true);
              this.requestAccountHolders({ accountId: resp.response.AccountId });

              this.props.onChange(updated);
            } else {
              const errors = resp.response.errors || [];
              const errorDesc = errors.join("\n");
              const errorsShow = { AccountName: errorDesc };
              const { dispatch } = this.props;

              if (this.props.order.OrderIsBasket) {
                this.props.setBasketErrors({ ...this.props.errors, AccountName: errorDesc });
              } else {
                dispatch({ type: "FORCE_UPDATE_VALIDATION", errors: errorsShow });
              }
              console.error(
                "ManageCustomerExternalAccount error",
                resp.response.result.Description + "\n" + errorDesc,
              );
            }
          })
          .catch((err) => {
            console.error("ManageCustomerExternalAccount error", err);
            this.props.onChange(_value);
          });
        return;
      }

      this.requestAccountInfo(_value, true);
      this.requestAccountHolders({ accountId: value.id });
      this.setState({
        holders: null,
        balance: null,
        loadingHolders: true,
      });
    } else {
      this.setState({
        holders: null,
        balance: null,
        instructions: null,
      });
      _value.AccountName = value;
    }

    this.props.onChange(_value);
  };

  getCommissionItemsWithPoints = () => {
    const { order } = this.props;
    const baseItems = getCommissionItems(order.AssetClassForm, order.OrderType);
    let items = [...baseItems];

    if (
      this.state.useCommissionPoints &&
      [OrderPriceType.LIMIT, OrderPriceType.STOPLIMIT, OrderPriceType.MARKET].includes(order.OrderType)
    ) {
      items.push({ id: "Points", description: this.state.commissionPointsLabel });
    }

    if (
      this.state.useCommissionClientPrice &&
      [OrderPriceType.LIMIT, OrderPriceType.MARKET].includes(order.OrderType)
    ) {
      const clientPriceDescription =
        order.AssetClassForm === ProductType.MMARKET ? "Client rate" : this.state.commissionClientPriceLabel;

      items.push({
        id: "ClientPrice",
        description: clientPriceDescription,
      });
    }

    return items;
  };

  onSetAttachment = (file) => {
    const { dispatch, account } = this.props;
    const { AccountId } = account;
    dispatch({ type: "SET_ATTACHMENT", payload: { id: AccountId, file } });
  };

  onResendAuth = (orderId, accountId) => {
    this.setState({ sendingMail: true });
    this.props.resendAuth(orderId, accountId);
    setTimeout(() => {
      this.setState({ sendingMail: false });
    }, 1000);
  };

  onSelectedAccountChange = (accountNumber) => {
    const changes = { clientBankAccount: accountNumber };
    this.props.order.CurrentAccount.selectedAccount = accountNumber;
    if (this.props.order.OrderSide === "Sell" && accountNumber) {
      changes.useCashAccount = false;
    }
    this.props.onChange(changes);
  };

  onCheckCashAccount = (evt) => {
    const changes = { useCashAccount: !!!this.props.order.CurrentAccount.useCashAccount };
    if (this.props.order.OrderSide === "Sell") {
      changes.clientBankAccount = null;
    }
    this.props.onChange(changes);
  };

  onChangeAvailableAccounts = (accounts) => {
    const changes = { clientBankAccounts: accounts };
    this.props.onChange(changes);
  };

  render() {
    const {
      order,
      account,
      readonly,
      hiddens,
      errors,
      balanceReady,
      attachContent,
      downloadAttachment,
      orderPdf,
      attachmentDisabled,
      hasAttachment,
      onChange,
      onChangeOrder,
      userType,
      imgSource,
      opsViewAccountName,
    } = this.props;

    const {
      AccountId,
      AccountName,
      AccountNumber,
      AccountType,
      HolderId,
      HolderName,
      Quantity,
      AccountAsksCustody,
      RequiresSpecialCustody,
      AccountUseMarkUP,
      Markup,
      MarkupType,
      FXMarkup,
      FXMarkupType,
      Commission,
      CommissionType,
      CurrentInfoDate,
      clientBankAccounts,
      clientBankAccount,
      useCashAccount,
      differCommissionPayment,
      Advice,
    } = order.CurrentAccount;
    const {
      OrderId,
      OrderSide,
      AssetClassForm,
      AssetPriceIsDiscounted,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol,
      AssetCanBeSelfCustodied,
      OrderQuantityIsCash,
      SubAssetClassDecimalPlaces,
      OrderAllowsMarkup,
      OrderTerm,
      OrderAssetData,
    } = order;
    const { state: contextState } = this.context;
    const { entities: contextEntities } = contextState;
    const { settlementCurrencies } = contextEntities;

    let showBankAccounts = true;
    if (OrderAssetData && OrderAssetData.items["FundX"]) {
      showBankAccounts = false;
    }

    const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
      settlementCurrencies,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol,
    );

    let custodyHidden = false;
    let markupHidden = false;
    let FXMarkupHidden = false;
    let commissionHidden = false;
    let custodyReadonly = false;
    let commissionPaymentHidden = false;
    if (
      (!AccountType && userType === UserType.Trader) ||
      (AccountType && AccountType.toLowerCase() !== "customer")
    ) {
      custodyHidden = true;
      markupHidden = true;
      FXMarkupHidden = true;
      commissionHidden = true;
      commissionPaymentHidden = true;
    } else {
      switch (AssetClassForm) {
        case ProductType.FOREX:
          markupHidden = true;
          FXMarkupHidden = true;
          commissionHidden = true;
          commissionPaymentHidden = true;
          break;
        case ProductType.MMARKET:
          FXMarkupHidden = true;
          break;
        default:
          break;
      }
      if (!OrderSettlementCurrencySymbol || OrderCurrencySymbol == OrderSettlementCurrencySymbol) {
        FXMarkupHidden = true;
      }
      if (OrderSide == "Buy" && AssetCanBeSelfCustodied) {
        custodyHidden = false;
        if (AccountAsksCustody) {
          custodyReadonly = true;
        }
      } else {
        custodyHidden = true;
      }
    }

    if (
      OrderAllowsMarkup === false ||
      AccountUseMarkUP === false ||
      [ProductType.REPO, ProductType.FUTURE].includes(AssetClassForm)
    ) {
      markupHidden = true;
      FXMarkupHidden = true;
    }

    const modHiddens = {
      ...hiddens,
      RequiresSpecialCustody: custodyHidden,
      Markup: markupHidden,
      MarkupType: markupHidden,
      FXMarkup: FXMarkupHidden,
      FXMarkupType: FXMarkupHidden,
      Commission: commissionHidden,
      CommissionType: commissionHidden,
      DifferCommissionPayment: commissionPaymentHidden,
    };

    const currentDayData = account.Day ? account.Day.find((day) => day.Date === CurrentInfoDate) : undefined;

    const currentDay = currentDayData
      ? {
          AssignedQty: currentDayData.AssignedQty || 0,
          ExecutionsAvgPrice: currentDayData.ExecutionsAvgPrice || 0,
          ExecutionsAvgFX: currentDayData.ExecutionsAvgFX || 0,
          Status: currentDayData.Status || "New",
        }
      : {
          AssignedQty: 0,
          ExecutionsAvgPrice: 0,
          ExecutionsAvgFX: 0,
          Status: "New",
        };

    const currentDayIsReadOnly = currentDay.Status == "Booked";

    const isExistingAccount = order.Accounts
      ? !!order.Accounts.find((acc) => acc.index === account.index)
      : false;

    let modReadonly = {
      ...readonly,
      RequiresSpecialCustody: readonly.RequiresSpecialCustody || custodyReadonly,
      Markup: readonly.Markup || currentDayIsReadOnly,
      MarkupType: readonly.MarkupType || currentDayIsReadOnly,
      FXMarkup: readonly.FXMarkup || currentDayIsReadOnly,
      FXMarkupType: readonly.FXMarkupType || currentDayIsReadOnly,
      Commission: readonly.Commission || currentDayIsReadOnly,
      CommissionType: readonly.CommissionType || currentDayIsReadOnly,
      AccountName: readonly.AccountName || isExistingAccount,
      differCommissionPayment: readonly.differCommissionPayment || currentDayIsReadOnly,
    };

    const userIsOwner =
      !AccountType ||
      AccountType == "" ||
      (userType == UserType.Trader && AccountType != "Customer") ||
      (userType == UserType.Advisor && AccountType == "Customer");

    if (!userIsOwner) {
      Object.keys(order.CurrentAccount).forEach((key) => {
        modReadonly[key] = true;
      });
    }

    let canResend = false;
    if (order.canResendAuthorizations) {
      if (account.Instruction === "ViaLink") {
        canResend = true;
      }
    }

    const isProp =
      account.AccountId && this.state.ownPositionAccounts.find((accountId) => accountId == account.AccountId);

    const hideHolders = this.state.holders !== null && this.state.holders.length == 0 && !isProp;

    let quantities = [];
    let quantityTitle = <span>Quantity</span>;
    let markupTitle = <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let FXMarkupTitle = <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let commissionTitle = <span>Commission</span>;
    let differCommissionPaymentTitle = <span>Differ Commission Payment</span>;
    let isPartiallyBooked = false;
    if (account.Day) {
      quantities = account.Day.map((day) => {
        if (day.Status == "Booked") {
          // If account is booked at least for one day, then:
          // - We can't change the account.
          isPartiallyBooked = true;
        }
        return {
          date: day.Date,
          status: day.Status,
          quantity: parseFloat(day.AssignedQty),
          markup: parseFloat(day.Markup),
          markupType: day.MarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          FXMarkup: parseFloat(day.FXMarkup),
          FXMarkupType: day.FXMarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          commission: parseFloat(day.Commission),
          commissionType: day.CommissionType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
        };
      });
    }
    quantityTitle = (
      <Fragment>
        <span>Quantity</span>
        {quantities.length > 0 && OrderId > 0 && (
          <QuantityHelper quantities={quantities} name="account">
            <i className="icon-info icons" />
          </QuantityHelper>
        )}
      </Fragment>
    );
    markupTitle = (
      <Fragment>
        <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper quantities={quantities} earningCategoryName="markup" earningTypeName="markupType">
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    FXMarkupTitle = (
      <Fragment>
        <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="FXMarkup"
            earningTypeName="FXMarkupType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    commissionTitle = (
      <Fragment>
        <span>Commission</span>
        {quantities.length > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="commission"
            earningTypeName="commissionType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    differCommissionPaymentTitle = (
      <Fragment>
        <span>Differ Commission Payment</span>
      </Fragment>
    );

    if (isPartiallyBooked) {
      modReadonly = {
        ...modReadonly,
        AccountName: true,
        HolderName: true,
        Instruction: true,
        RequiresSpecialCustody: true,
        Quantity: true,
      };
    }

    const accountOnlyNumbers = !!window.___APP_CONFIG___.AccountOnlyNumbers;

    const inputProps = {
      placeholder: `${translate("Account")}`,
      disabled: modReadonly.AccountName,
      invalid: !!errors.AccountName,
      ...(accountOnlyNumbers && {
        onKeyPress: (e) => {
          if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
          }
        },
        onPaste: (e) => {
          const pasted = e.clipboardData.getData("text");
          if (!/^[0-9]*$/.test(pasted)) {
            e.preventDefault();
          }
        },
      }),
    };

    const hasDifferentCurrencies = OrderCurrencySymbol !== OrderSettlementCurrencySymbol;

    const earningsTitle = `Values for ${CurrentInfoDate} (Q: ${formattedNumber(
      currentDay.AssignedQty,
      "quantity",
    )}; P: ${formattedNumber(currentDay.ExecutionsAvgPrice, "price")}${
      hasDifferentCurrencies
        ? `; FX [${baseCurrency}/${priceCurrency}]: ${formattedNumber(
            currentDay.ExecutionsAvgFX,
            "currency",
          )}`
        : ""
    }):`;

    let defaultMaxDecimals = 2;
    switch (order.AssetClassForm) {
      case ProductType.BOND:
      case ProductType.EQUITY:
      case ProductType.OPTION:
        defaultMaxDecimals = 0;
        break;
      case ProductType.MFUNDS:
      case ProductType.MMARKET:
        defaultMaxDecimals = 5;
        break;
      case ProductType.FOREX:
        defaultMaxDecimals = 2;
        break;
      default:
        defaultMaxDecimals = 2;
    }

    const quantityMaxDecimals = OrderQuantityIsCash ? 2 : SubAssetClassDecimalPlaces || defaultMaxDecimals;

    const isClientPriceMode =
      this.state.useCommissionClientPrice &&
      [OrderPriceType.LIMIT, OrderPriceType.MARKET].includes(order.OrderType) &&
      CommissionType === "ClientPrice";

    const showClientPrice =
      [OrderPriceType.LIMIT, OrderPriceType.STOPLIMIT, OrderPriceType.MARKET].includes(order.OrderType) ||
      currentDay.ExecutionsAvgPrice != 0 ||
      isClientPriceMode;
    const showClientFX = hasDifferentCurrencies && currentDay.ExecutionsAvgFX != 0;

    const originalPrice =
      currentDay.ExecutionsAvgPrice != 0
        ? currentDay.ExecutionsAvgPrice
        : order.OrderType === OrderPriceType.MARKET
          ? this.getMarketReferencePrice(order)
          : order.OrderPrice;

    const originalFX = currentDay.ExecutionsAvgFX;

    // Calcular el precio del cliente basado en la comisión
    const calculateClientPriceWithCommission = () => {
      if (
        this.state.useCommissionPoints &&
        [OrderPriceType.LIMIT, OrderPriceType.STOPLIMIT, OrderPriceType.MARKET].includes(order.OrderType) &&
        CommissionType === "Points" &&
        Commission != undefined &&
        Commission !== "" &&
        originalPrice != undefined &&
        originalPrice !== ""
      ) {
        const commission = +Commission;
        const price = +originalPrice;
        if (AssetPriceIsDiscounted) {
          const sideSign = OrderSide === "Buy" ? -1 : 1;
          return price + sideSign * commission;
        } else {
          const sideSign = OrderSide === "Buy" ? 1 : -1;
          return price + sideSign * commission;
        }
      }

      return clientPrice(order.OrderSide, MarkupType, Markup, originalPrice, AssetPriceIsDiscounted);
    };

    const isCommissionNegative =
      this.state.useCommissionClientPrice &&
      [OrderPriceType.LIMIT, OrderPriceType.MARKET].includes(order.OrderType) &&
      CommissionType === "ClientPrice" &&
      Commission !== undefined &&
      Commission !== null &&
      Commission !== "" &&
      +Commission < 0;

    const clientPriceLabel = AssetClassForm === ProductType.MMARKET ? "Client rate" : "Client Price";

    return (
      <div>
        {/* ##### Quantity ###### */}
        {!modHiddens.Quantity && (
          <Field label={quantityTitle} error={errors.Quantity}>
            <Numeric
              value={Quantity}
              placeholder={"Quantity"}
              disabled={modReadonly.Quantity}
              onChange={(v) => onChange({ Quantity: v })}
              invalid={!!errors.Quantity}
              dataTypeDecimalName="quantity"
            />
          </Field>
        )}

        {/* ##### Account ###### */}
        <FormGroup>
          <Field label={`${translate("Account")}: `} error={errors.AccountName}>
            <Autosuggest
              renderSuggestion={renderSuggestion}
              getSuggestionValue={getSuggestionValue}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              inputProps={inputProps}
              onChange={this.onChange}
              value={
                opsViewAccountName !== undefined
                  ? opsViewAccountName
                    ? AccountNumber
                      ? `${AccountNumber} - ${AccountName}`
                      : ""
                    : AccountNumber
                      ? `${AccountNumber}`
                      : ""
                  : AccountNumber
                    ? `${AccountNumber} - ${AccountName}`
                    : ""
              }
            />
          </Field>
        </FormGroup>

        {this.state.loadingHolders ? (
          <CircularProgress sm />
        ) : (
          <div>
            {!hideHolders && !isProp && (
              <Field label="Holder" error={errors.HolderName}>
                <Holders
                  name={HolderName}
                  value={HolderId}
                  items={this.state.holders}
                  disabled={modReadonly.HolderName}
                  invalid={!!errors.HolderName}
                  onChange={this.onChangeAccountHolder}
                />
              </Field>
            )}

            <ExternalAccountWrapper
              getAccountsService={this.props.getUserExternalAccounts}
              accounts={clientBankAccounts}
              logo={imgSource}
              selectedAccount={clientBankAccount}
              selectedCash={useCashAccount}
              onChange={this.onSelectedAccountChange}
              onCheckCashAccount={this.onCheckCashAccount}
              currencyISO={order.OrderCurrencySymbol}
              account={account}
              error={errors.clientBankAccounts}
              disabled={modReadonly.HolderName}
              onChangeAvailableAccounts={this.onChangeAvailableAccounts}
              getParameterValue={this.props.getParameterValue}
              orderSide={OrderSide}
            />

            {this.state.loadingBalance ? (
              <CircularProgress sm />
            ) : (
              balanceReady && this.state.balance != null && <Balance balance={this.state.balance} />
            )}
            {!hideHolders && (
              <Instruction
                value={account.Instruction}
                InstructionType={account.InstructionType}
                items={this.state.instructions}
                attachmentDisabled={attachmentDisabled}
                userType={userType}
                disabled={modReadonly.Instruction || HolderId == null}
                error={errors.Instruction}
                onChange={this.onChangeInstruction}
                onChangeOrder={onChange}
                setAttachment={this.onSetAttachment}
                downloadAttachment={downloadAttachment}
                orderId={OrderId}
                orderPdf={orderPdf}
                hasAttachment={hasAttachment}
                accountId={AccountId}
                canResend={canResend}
                hasFile={account.HasFile}
                onResendAuth={this.onResendAuth}
                sendingMail={this.state.sendingMail}
                isProp={isProp}
                getParameterValue={this.props.getParameterValue}
              />
            )}
          </div>
        )}
        {/* ##### Custody ###### */}
        {!modHiddens.RequiresSpecialCustody && (
          <Field>
            <Switch
              value={RequiresSpecialCustody || false}
              label={"Custody"}
              disabled={modReadonly.RequiresSpecialCustody}
              onChange={(v) => onChange({ RequiresSpecialCustody: v })}
            />
          </Field>
        )}

        {!(modHiddens.Markup && modHiddens.FXMarkup && modHiddens.Commission) && OrderId > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <u>{earningsTitle}</u>
          </div>
        )}

        {!modHiddens.Markup && (
          <Fragment>
            <Row>
              {/* ##### Mark up/down ###### */}
              <Col lg={6}>
                <Field label={markupTitle} error={errors.Markup}>
                  <Numeric
                    value={Markup}
                    placeholder={`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                    disabled={modReadonly.Markup}
                    onChange={(v) => onChange({ Markup: v })}
                    invalid={!!errors.Markup}
                    {...commissionSuffix(MarkupType, order.OrderCurrencySymbol)}
                    dataTypeDecimalName="currency"
                  />
                </Field>
              </Col>

              {/* ##### Mark type ###### */}
              <Col lg={6}>
                <Field label={"Type"} error={errors.MarkupType}>
                  <Combobox
                    value={MarkupType}
                    items={getCommissionItems(order.AssetClassForm)}
                    disabled={modReadonly.MarkupType}
                    onChange={(v) => onChange({ MarkupType: v })}
                    emptyLabel={"Type"}
                    invalid={!!errors.MarkupType}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>
            </Row>

            {/* ##### Client Price ###### */}
            {showClientPrice && !modHiddens.showClientPrice && (
              <Field label={clientPriceLabel}>
                <Numeric
                  value={
                    isClientPriceMode
                      ? order.CurrentAccount.ClientPrice
                      : calculateClientPriceWithCommission()
                  }
                  placeholder={clientPriceLabel}
                  onChange={(v) => {
                    if (isClientPriceMode) {
                      if (!v || !originalPrice || v === "" || originalPrice === "") {
                        onChange({
                          ClientPrice: v,
                          Commission: "",
                        });
                      } else {
                        const clientPriceNum = +v;
                        const priceNum = +originalPrice;
                        const sideSign = OrderSide === "Buy" ? 1 : -1;
                        let calculatedCommission;

                        if (AssetPriceIsDiscounted) {
                          calculatedCommission = sideSign * (priceNum - clientPriceNum);
                        } else {
                          calculatedCommission = sideSign * (clientPriceNum - priceNum);
                        }

                        onChange({
                          ClientPrice: v,
                          Commission: calculatedCommission,
                        });
                      }
                    }
                  }}
                  disabled={!isClientPriceMode}
                  dataTypeDecimalName="price"
                  decimalScale={SubAssetClassDecimalPlaces}
                />
              </Field>
            )}

            {/* #### FX Mark up/down #### */}
            {!modHiddens.FXMarkup && readonly.FXMarkupAllowed && (
              <Row>
                <Col lg={6}>
                  <Field label={FXMarkupTitle} error={errors.FXMarkup}>
                    <Numeric
                      value={FXMarkup}
                      placeholder={`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                      disabled={modReadonly.FXMarkup}
                      onChange={(v) => onChange({ FXMarkup: v })}
                      invalid={!!errors.FXMarkup}
                      {...commissionSuffix(FXMarkupType, `${baseCurrency}/${priceCurrency}`)}
                      dataTypeDecimalName={
                        FXMarkupType == ComType.PrincipalPercentage ? "percenttage" : "default"
                      }
                    />
                  </Field>
                </Col>

                {/* ##### FX Mark type ###### */}
                <Col lg={6}>
                  <Field label={"Type"} error={errors.FXMarkupType}>
                    <Combobox
                      value={FXMarkupType}
                      items={getCommissionItems(order.AssetClassForm, order.OrderType)}
                      disabled={modReadonly.FXMarkupType}
                      onChange={(v) => onChange({ FXMarkupType: v })}
                      emptyLabel={"Type"}
                      invalid={!!errors.FXMarkupType}
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                    />
                  </Field>
                </Col>
              </Row>
            )}

            {/* ##### Client Price ###### */}
            {showClientFX && (
              <Field label={"Client FX"}>
                <Numeric
                  value={clientPrice(order.OrderSide, FXMarkupType, FXMarkup, originalFX, false)}
                  placeholder={"Client FX"}
                  onChange={(v) => null}
                  disabled
                  dataTypeDecimalName="currency"
                />
              </Field>
            )}
          </Fragment>
        )}

        {isClientPriceMode && modHiddens.Markup && (
          <Field label={clientPriceLabel} error={errors.ClientPrice}>
            <Numeric
              value={order.CurrentAccount.ClientPrice}
              placeholder={clientPriceLabel}
              invalid={!!errors.ClientPrice}
              onChange={(v) => {
                if (!v || !originalPrice || v === "" || originalPrice === "") {
                  onChange({
                    ClientPrice: v,
                    Commission: "",
                  });
                } else {
                  const clientPriceNum = +v;
                  const priceNum = +originalPrice;
                  const sideSign = OrderSide === "Buy" ? 1 : -1;
                  let calculatedCommission;

                  if (AssetPriceIsDiscounted) {
                    calculatedCommission = sideSign * (priceNum - clientPriceNum);
                  } else {
                    calculatedCommission = sideSign * (clientPriceNum - priceNum);
                  }

                  onChange({
                    ClientPrice: v,
                    Commission: calculatedCommission,
                  });
                }
              }}
              dataTypeDecimalName="price"
              decimalScale={SubAssetClassDecimalPlaces}
            />
          </Field>
        )}

        {AssetClassForm == ProductType.REPO && (
          <Row>
            {/* ##### Term ###### */}
            <Col lg={12}>
              <Field label="Term" error={errors.OrderTerm}>
                <Numeric
                  value={OrderTerm}
                  placeholder={`Term`}
                  disabled={modReadonly.OrderTerm}
                  onChange={(v) => onChangeOrder({ OrderTerm: v })}
                  invalid={!!errors.OrderTerm}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>
          </Row>
        )}

        {!modHiddens.Commission && (
          <Row>
            {/* ##### Commission ###### */}
            <Col lg={6}>
              <Field
                label={commissionTitle}
                error={isCommissionNegative ? "Commission cannot be negative" : errors.Commission}
              >
                <Numeric
                  value={Commission}
                  placeholder={`Commission`}
                  disabled={modReadonly.Commission || isClientPriceMode}
                  onChange={(v) => onChange({ Commission: v })}
                  invalid={!!errors.Commission || isCommissionNegative}
                  decimalScale={3}
                  {...commissionSuffix(CommissionType, order.OrderSettlementCurrencySymbol)}
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.CommissionType}>
                <Combobox
                  value={CommissionType}
                  items={this.getCommissionItemsWithPoints()}
                  disabled={modReadonly.CommissionType}
                  invalid={!!errors.CommissionType}
                  onChange={(v) => {
                    onChange({ CommissionType: v });
                  }}
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        )}
        {!modHiddens.DifferCommissionPayment && this.state.accountIsJuridical && this.state.isMainHolder && (
          <Row>
            <Col lg={6}>
              <Field label={differCommissionPaymentTitle}></Field>
            </Col>
            <Col>
              <CheckFormField
                name="differCommissionPayment"
                label=""
                disabled={modReadonly.differCommissionPayment}
                initialValue={differCommissionPayment || false}
                value={differCommissionPayment}
                onChange={(n, v) => {
                  onChange({ differCommissionPayment: v });
                }}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Label
              className="switch switch-text switch-pill switch-secondary switch-lg"
              style={{ marginBottom: "0px" }}
            >
              <Input
                type="checkbox"
                className="switch-input"
                onChange={(e) => onChange({ Advice: e.target.checked })}
                defaultChecked={!!Advice}
                value={!!Advice}
              />
              <span className="switch-label" data-on="Yes" data-off="No"></span>
              <span className="switch-handle"></span>
            </Label>
            <Label
              style={{
                marginBottom: "5px",
                marginLeft: "5px",
                verticalAlign: "bottom",
              }}
            >
              Advice
            </Label>
          </Col>
        </Row>
      </div>
    );
  }
}

const defaultAccountValue = {
  AccountId: null,
  AccountName: "",
  HolderId: null,
  HolderName: null,
  Instruction: null,
  differCommissionPayment: false,
};

const renderSuggestion = (suggestion) => (
  <div className={styleF.suggestionItem}>
    {suggestion.number}
    {" - "}
    <span>{suggestion.name}</span>
  </div>
);

const getSuggestionValue = (suggestion) => `${suggestion.number} - ${suggestion.name}`;

const getInstructions = (holder, isBasket) => {
  const instructions = [];
  if (holder.HoldersOrderNO) instructions.push({ id: "Managed", description: "Managed" });
  else {
    if (holder.HoldersOrderW) instructions.push({ id: "Written", description: "Written" });
    if (holder.HoldersOrderV && !isBasket) instructions.push({ id: "Web", description: "Web" });
    if (holder.HoldersOrderL) instructions.push({ id: "ViaLink", description: "Via Link" });
  }

  return instructions;
};

const getItemById = (items, id) => items.find((e) => e.id === id);

const isEmpty = (value) => value === undefined || value === "";

export default Account;
